exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-ai-robot__wrap--img[data-v-a0b147be]{width:16px;height:16px;vertical-align:middle;margin-right:8px;padding:6px;background:#F4F5F6;border-radius:4px}\n", ""]);

